.iconBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 7px;
  color: var(--color-text-muted);
  cursor: pointer;
  flex-shrink: 0;
  transition: transform 60ms var(--ease-out), background var(--motion-fast) var(--ease-out), color var(--motion-fast) var(--ease-out);
}

.iconBtn:hover:not(:disabled) {
  background: var(--color-bg-surface);
  color: var(--color-text);
}

.iconBtn:active:not(:disabled) {
  transform: scale(0.88);
  background: var(--color-bg-surface-hover);
}

.iconBtn:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

@media (pointer: coarse) {
  .iconBtn {
    width: 40px;
    height: 40px;
  }
}
